import AbsComponent from "../AbsComponent";
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from '../../common/bodyScrollLock.es6';

class RecentHistory extends AbsComponent{
    constructor(_store={}, _router={}, _el=''){
        super('class RecentHistory', _store, _router, _el);

        let watchRecentList = this.watch(this.store.getState, 'recentlyViewList', this.isEqual);
        this.store.subscribe( watchRecentList( (newVal, oldVal, path) => this.render(newVal, oldVal, path)));

        let watchisRecentShow = this.watch(this.store.getState, 'isRecentShow', this.isEqual);
        this.store.subscribe( watchisRecentShow( (newVal, oldVal, path) => this.showHide(newVal)));

        let watchItemId = this.watch(this.store.getState, 'itemId', this.isEqual);
        this.store.subscribe( watchItemId( (_newVal, _oldVal, _path) => this.changeItemId(_newVal) ) );

        let watchSkillId = this.watch(this.store.getState, 'skillId', this.isEqual);
        this.store.subscribe( watchSkillId( (_newVal, _oldVal, _path) => this.changeItemId(_newVal) ) );

        let recentlyViewList = JSON.parse(localStorage.getItem('gameDicRecentlyViewList'+this.store.getState().config.tab));
        this.store.dispatch( this.actions.setRecentList( recentlyViewList || [] ) );

        this.addEvents();
    }

    addEvents(){
        $(this.el + ' .gd-btn-recent-search').on('click', (e)=>{
            let isShow = $(this.el + ' .gd-recent-search-layer-wrap').is(':visible');
            this.store.dispatch( this.actions.setIsRecentShow(!isShow) );
            return false;
        });
        $(this.el + ' .gd-recent-search-layer .gd-btn-close-layer').on('click', (e)=>{
            this.store.dispatch( this.actions.setIsRecentShow(false) );
            return false;
        });
        $('body').on('click',(e)=> {
            if($(e.target).parents('.gd-recent-search-layer').length<1){
                this.store.dispatch( this.actions.setIsRecentShow(false) );
            }
        });
    }

    render(_newVal){
        $(this.el + ' .gd-btn-recent-search').toggle(_newVal.length>0);
        let dbname = {
            'itemid': '아이템',
            'skillid': '스킬',
        };
        let list = _newVal.map((it)=>{
            let el = $(`
            <li data-id="${it.id}" class="${ it.id == this.store.getState().itemId? 'is-active': ''} ${it.db}-${it.id}">
                <button href="" class="gd-recent-search-link">
                    <span>${dbname[it.db]}</span>
                    <em>${it.name.replace( /</g, '&lt;' ).replace( />/g, '&gt;' )}</em>
                </button>
            </li>`);
            el.on('click', (e)=>{
                this.store.dispatch( this.actions.setIsRecentShow(false) );
                this.store.dispatch( this.actions.setDetailIsshow(true));
                this.router.goSingleParam( it.db, it.id );
            });

            return el;
        });
        $(this.el + ' .gd-recent-search-list').html(list);
    }

    showHide(_newVal){
        $(this.el + ' .gd-recent-search-layer-wrap').toggleClass('is-show', _newVal);
        $(this.el + ' .gd-btn-recent-search').toggleClass('is-active', _newVal);
        if(_device != 'pc' && _device != 'launcher' && _newVal){
            disableBodyScroll($('.gd-recent-search-list')[0]);
        }else{
            enableBodyScroll($('.gd-recent-search-list')[0]);
        }
    }

    changeItemId(_newVal){
        if( _newVal == '' ) return;
        $(this.el + ' .gd-recent-search-list li').removeClass('is-active');
        $(this.el + ` .gd-recent-search-list li[data-id="${_newVal}"]`).addClass('is-active');
    }






} // end of class
export default RecentHistory;
